<template>
  <div
    class="ecogas-gallery">
    <div
      v-slider-swipe="{ left: $_swipeLeft, right: $_swipeRight }"
      v-slider="{ onClick: $_onElementClick }"
      ref="elements"
      class="ecogas-gallery__slides">
      <picture
        v-for="(slide, index) of gallery"
        @click="slide.zoomImage ? _zoomDato(slide.zoomImage && slide.zoomImage.responsiveImage ? slide.zoomImage && slide.zoomImage.responsiveImage.src : slide.image.responsiveImage.src ) : ''"
        class="ecogas-gallery__slides__slide"
        :class="{'ecogas-gallery__slides__slide--noTouch': !touch}"
        draggable="false"
        :key="index">
          <source :srcset="slide.image.responsiveImage.src" media="(min-width: 1000px)">
          <img draggable="false" :src="slide.image.responsiveImage.src" :alt="index">
      </picture>
    </div>
    <div class="default-container">
      <div class="ecogas-gallery__arrows">
        <div
          class="ecogas-gallery__arrows__prev"
          @click="$_swipeRight">
            <img src="/come-funziona/arrow-right.svg" alt="arrow right" width="18px" height="18px" />
        </div>
        <p>{{ currentSlide + 1 }}/{{ elementsCount }}</p>
        <div
          class="ecogas-gallery__arrows__next"
          @click="$_swipeLeft">
            <img src="/come-funziona/arrow-right.svg" alt="arrow right" width="18px" height="18px" />
        </div>
      </div>
    </div>
    <div
      :style="{ backgroundImage: zoomImage }"
      :class="{ 'velinaUp': velinaOpen }"
      class="ecogas-gallery__velina-zoom">
        <div
          class="overlay-back"
          @click="_zoomOut">
            {{$t('closeLabel')}}
        </div>
    </div>
  </div>
</template>

<script>
import Hammer from 'hammerjs'
import _ from 'lodash'
import { mapGetters, mapActions } from 'vuex'

export default {
  data: () => ({
    ended: false,
    currentSlide: 0,
    elementsCount: 0,
    swiping: false,
    velinaOpen: false,
    currentZoomImage: ''
  }),
  props: {
    galleryId: {
      type: String,
      default: () => '0'
    },
    lang: {
      type: String,
      required: true
    },
    gallery: {
      type: Array,
      default: () => ([])
    }
  },
  computed: {
    ...mapGetters([
      'pictureGallery',
      'touch'
    ]),
    imgServer: {
      get () {
        return process.env.VUE_APP_ENDPOINT
      }
    },
    pictureGalleryApiInput: {
      get () {
        return {
          lang: this.lang,
          id: this.galleryId
        }
      }
    },
    hydratedData: {
      get () {
        return this.pictureGallery({
          lang: this.lang,
          id: this.galleryId
        }) || null
      }
    },
    zoomImage: {
      get () {
        return `url(${this.currentZoomImage})`
      }
    }
  },
  methods: {
    ...mapActions([
      'loadPictureGallery'
    ]),
    $_onElementClick (element, elementsCount, index, scroll = true) {
      if (this.swiping) return
      this.$_scrollTo(element, elementsCount, index, scroll)
    },
    $_scrollTo (element, elementsCount, index, scroll = true) {
      this.currentSlide = index
      this.elementsCount = elementsCount

      if (!scroll) return
      const parentNode = element.parentNode
      parentNode.scrollTo({
        top: 0,
        left: element.offsetLeft - (parentNode.offsetWidth / 2 - element.offsetWidth / 2),
        behavior: 'smooth'
      })
    },
    $_swipeLeft () {
      this.swiping = true
      window.requestAnimationFrame(() => { this.swiping = false })
      const elements = Array.prototype.slice.call(this.$refs.elements.children)
      const currentElement = elements[this.currentSlide + 1]
      if (typeof currentElement !== 'undefined') this.$_scrollTo(currentElement, elements.length, this.currentSlide + 1)
    },
    $_swipeRight () {
      this.swiping = true
      window.requestAnimationFrame(() => { this.swiping = false })
      const elements = Array.prototype.slice.call(this.$refs.elements.children)
      const currentElement = elements[this.currentSlide - 1]
      if (typeof currentElement !== 'undefined') this.$_scrollTo(currentElement, elements.length, this.currentSlide - 1)
    },
    _zoom (img, imgPortrait) {
      if (window.innerWidth > window.innerHeight) { this.currentZoomImage = img } else this.currentZoomImage = imgPortrait
      if (window.innerWidth > window.innerHeight) this.velinaOpen = true
    },
    _zoomDato (img) {
      this.currentZoomImage = img
      if (window.innerWidth > window.innerHeight) this.velinaOpen = true
    },
    _zoomOut () {
      this.velinaOpen = false
    }
  },
  watch: {
    pictureGalleryApiInput: {
      handler (input) {
        this.loadPictureGallery(input)
      },
      deep: true,
      immediate: true
    }
  },
  directives: {
    slider: {
      bind (el, binding) {
        const elements = Array.prototype.slice.call(el.children)
        _.forEach(elements, (element, key) => { element.addEventListener('click', binding.value.onClick.bind(undefined, element, elements.length, key)) })
        binding.value.onClick(elements[0], elements.length, 0, false)
      },
      unbind (el, binding) {
        const elements = Array.prototype.slice.call(el.children)
        _.forEach(elements, (element, key) => { element.removeEventListener('click', binding.value.onClick.bind(undefined, element, elements.length, key)) })
      }
    },
    'slider-swipe': {
      bind (el, binding) {
        const manager = new Hammer.Manager(el)
        const swipe = new Hammer.Swipe()
        manager.add(swipe)
        manager.on('swipeleft', binding.value.left)
        manager.on('swiperight', binding.value.right)
      }
    }
  }
}
</script>

<style lang="scss">
@import "../assets/mixins/breakpoints";

.ecogas-gallery {
  width: 100%;
  padding: 2rem 0;
}

.ecogas-gallery__slides {
  white-space: nowrap;
  position: relative;
  box-sizing: border-box;
  overflow: hidden;

  padding-left: 10px;

  @media #{$large_mq} {
    padding-left: calc((100vw - 750px + 21px)/2);
  }
  @media #{$xlarge_mq} {
    padding-left: calc((100vw - 850px + 21px)/2);
  }
  @media #{$xxlarge_mq} {
    padding-left: calc((100vw - 950px + 21px)/2);
  }

  img{
    width: 100%;
    height: auto;
  }
}

.ecogas-gallery__slides__slide {
  display: inline-block;
  width: 100%;
  max-width: 700px;
  @media #{$medium_mq} {

    width: auto;
    margin-right: 2.5%;
    margin-left: 2.5%;

    &:first-child {
        margin-left: 0;
    }
  }
}

.ecogas-gallery__slides__slide.ecogas-gallery__slides__slide--noTouch::before{
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  opacity: 0;
  cursor: pointer;
  z-index: 2;
  background-color: rgba(48, 174, 141, .6);

  transition: opacity 400ms cubic-bezier(0.23, 1, 0.32, 1);
}

.ecogas-gallery__slides__slide.ecogas-gallery__slides__slide--noTouch:hover::before{
  opacity: 1;
}

.ecogas-gallery__counter__dot--active {
  background-color: gray;
}

.ecogas-gallery__arrows {
  padding: 2rem 0 4rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: nowrap;

  p{
    margin: 0;
    font-family: 'IBM Plex Mono', sans-serif;
    font-weight: 400;
    font-size: 1rem;
    top: -2px
  }

  div {
    display: inline-block;
    margin: 0 10px;
    cursor: pointer;

    svg {
      width: 24px;
      height: 29px;
    }
  }
}

.ecogas-gallery__arrows__prev img, .ecogas-gallery__arrows__next img{
  opacity: 1;
  -webkit-transition: opacity 0.3s;
  -moz-transition: opacity 0.3s;
  transition: opacity 0.3s;
}

.ecogas-gallery__arrows__prev:hover img, .ecogas-gallery__arrows__next:hover img{
  opacity: .5;
}

.ecogas-gallery__arrows__prev{
  img {
    transform: rotate3d(0, 0, 1, -180deg);
  }
}

.ecogas-gallery__velina-zoom{
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba($color: #000000, $alpha: .9);
  transform: translate3d(0, 100%, 0);

  background-position: center center;
  background-size: cover;

  transition: transform 400ms cubic-bezier(0.23, 1, 0.32, 1);
  z-index: 200;

  .hamburger-menu-container::before{
    top: 46%;
    left: 44%;
  }

  .hamburger-menu, .hamburger-menu::after, .hamburger-menu::before{
    height: 1px;
    width: 30px;
  }

}

.ecogas-gallery__velina-zoom.velinaUp{
  transform: translate3d(0, 0, 0);
}

</style>
